import type { AppState } from 'state/state.model';

export function getPendingQuoteDetailsMap(state: AppState) {
  return state.quotes.pendingDetails;
}
export function getPendingQuoteDetails(state: AppState, quoteId: string) {
  return getPendingQuoteDetailsMap(state)[quoteId];
}
